import { emojiRegex } from '@mentimeter/emojis';
import twemoji from '@twemoji/api';
import type {
  WordCloudData,
  WordCloudResultT,
} from '@mentimeter/visualizations';

export const getData = (results: WordCloudResultT[]): WordCloudData[] => {
  return results.map(({ text: rawText = '', count = 1 }) => {
    let emojiUrl = '';
    const text = rawText
      .toLowerCase()
      .replace(emojiRegex, ' $& ')
      .replace(/_+/g, ' ') // _ is the intra word separator
      .trim();
    const textWithoutEmoji = text.replace(emojiRegex, '').trim();
    const emojis = text.match(emojiRegex);
    // For responses with single emoji, use twemoji to get the image source
    if (textWithoutEmoji?.length === 0 && emojis?.length === 1) {
      twemoji.parse(text, {
        // check twemoji "callback" api before updating the package to ensure url stays intact
        callback: (icon, options) => {
          // issue with ❗️ emoji, renders itself AND tries to request /.svg (no icon)
          if (icon) {
            emojiUrl = `${(options as { base: string }).base}svg/${icon}.svg`;
            return emojiUrl;
          }
          return false;
        },
      });
    }
    return {
      key: text,
      text,
      value: count,
      emojiUrl,
    };
  });
};
